<!-- =========================================================================================
  File Name: FormSidebar
  Description: For adding or edditing user information
  ----------------------------------------------------------------------------------------
  Item Name: JogjaBagus Backoffice
  Author: Hifi Saputra
  Author Email: hifisaputra1@gmail.com
  Author URL: https://github.com/fei77
========================================================================================== -->

<template>
  <vs-sidebar
    click-not-close
    position-right
    parent="body"
    default-index="1"
    color="primary"
    class="add-new-data-sidebar items-no-padding"
    spacer
    v-model="isSidebarActiveLocal"
  >
    <div class="mt-6 flex items-center justify-between px-6">
      <h4>{{ formTitle }}</h4>
      <feather-icon
        icon="XIcon"
        @click.stop="isSidebarActiveLocal = false"
        class="cursor-pointer"
      ></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>

    <VuePerfectScrollbar
      class="scroll-area--data-list-add-new pb-6"
      :settings="settings"
    >
      <div
        class="p-6 vs-con-loading__container"
        id="form-sidebar"
      >

        <div class="flex">
          <vs-input
            label="Name ID"
            v-model="formData.nameId"
            class="mt-5 mr-3 w-full"
          />

          <vs-input
            label="Name EN"
            v-model="formData.nameEn"
            class="mt-5 w-full"
          />
        </div>

        <vs-checkbox
          class="mb-5 mt-5"
          v-model="isSubcategory"
        >Subcategory</vs-checkbox>

        <select-category-parent
          v-if="!formData.topLevel"
          :data="formData.parent"
          @change="parentCategoryChange"
        />

        <upload-image
          :src="formData.bannerUrl"
          @upload-success="formData.bannerUrl = $event"
          label="Default banner image for business in this category"
          :w="1583"
          :h="664"
        />

        <upload-image
          :src="formData.iconUrl"
          @upload-success="formData.iconUrl = $event"
          label="Icon"
        />

        <div class="mt-3">
          <label>Background Color</label> <br />
          <input
            type="color"
            v-model="formData.backgroundColor"
          >
        </div>

        <vs-divider>SEO</vs-divider>
        <vs-input
          label="Title ID"
          v-model="formData.titleId"
          class="mt-5 w-full"
        />

        <vs-input
          label="Title EN"
          v-model="formData.titleEn"
          class="mt-3 w-full"
        />

        <vs-textarea class="mt-5" label="Description EN" v-model="formData.descriptionEn" />
        <vs-textarea class="mt-5" label="Description ID" v-model="formData.descriptionId" />

        <tags-input label="Tags" :data="formData.tags" @add="formData.tags.push($event)" @remove="formData.tags.splice($event, 1)" />

      </div>
    </VuePerfectScrollbar>

    <div
      class="flex flex-wrap items-center justify-center p-6"
      slot="footer"
    >
      <vs-button
        class="mr-6"
        @click="submit"
      >Save</vs-button>
      <vs-button
        type="border"
        color="danger"
        @click="isSidebarActiveLocal = false"
      >Cancel</vs-button>
    </div>
  </vs-sidebar>
</template>

<script>
export default {
  props: {
    itemId: {
      type: String,
      default: null
    },
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    formTitle: {
      type: String,
      required: true
    },
    formData: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data () {
    return {
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: 0.6
      },
      loading: false,
      data: {}
    };
  },
  computed: {
    isSidebarActiveLocal: {
      get () {
        return this.isSidebarActive;
      },
      set (val) {
        if (!val) {
          this.$emit("closeSidebar");
        }
      }
    },
    validate () {
      return (this.formData.nameId.length > 0 && this.formData.nameEn.length > 0)
    },
    isSubcategory: {
      get () {
        return this.formData.topLevel === false
      },
      set (val) {
        this.formData.topLevel = !val
      }
    }
  },
  methods: {
    submit () {
      if (!this.validate) return false
      if (this.itemId) {
        this.updateItem();
      } else {
        this.createItem();
      }
    },
    updateItem () {
      this.$vs.loading();

      this.$store.dispatch('category/patch', this.formData)
        .then(() => {
          this.notifySuccess('Data updated')
          this.closeSidebar()
        })
        .catch(err => {
          this.notifySuccess(err.message)
        })
        .then(() => this.$vs.loading.close())
    },
    createItem () {
      this.$vs.loading();

      this.$store.dispatch('category/insert', this.formData)
        .then(() => {
          this.notifySuccess('Data created')
          this.closeSidebar()
        })
        .catch(err => {
          this.notifySuccess(err.message)
        })
        .then(() => this.$vs.loading.close())
    },
    closeSidebar () {
      this.$emit("closeSidebar")
    },
    parentCategoryChange (val) {
      this.formData.parentId = val.id
      this.formData.parent = val
    }
  }
};
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  /deep/ .vs-sidebar--background {
    z-index: 52010;
  }

  /deep/ .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
  height: calc(100% - 4.3rem);
}
</style>
